import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import ServerStatusTable from "../components/ServerStatusTable";
const ServerStatus = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleSidebarStateChange = (isOpen) => {
    setSidebarOpen(isOpen);
  };

  return (
    <div>
      <Sidebar onSidebarStateChange={handleSidebarStateChange} />
      <ServerStatusTable sidebarOpen={sidebarOpen} />
      
    </div>
  );
};

export default ServerStatus;
